/// <amd-module name="VSSUI/Components/Dialog/DialogInternal" />
import * as React from "react";

import { IDialogProps } from "VSSUI/Components/Dialog/Dialog.Props";
import { PanelCloseButtonSize } from "VSSUI/Components/Panel/Panel.Props";
import { TitleSize } from "VSSUI/Header";
import { PanelFooter, PanelHeader } from "VSSUI/Panel";
import { SurfaceContext } from "VSSUI/Surface";
import { css } from "VSSUI/Util";
import { CustomDialog } from "./CustomDialog";

let dialogId = 1;

export class DialogInternal extends React.Component<IDialogProps> {
    public static defaultProps = {
        showCloseButton: false
    };

    private dialogId = `dialog-${dialogId++}`;

    public render(): JSX.Element {
        const {
            ariaDescribedBy,
            ariaLabel,
            ariaLabelledBy,
            blurDismiss,
            calloutClassName,
            calloutContentClassName,
            className,
            contentJustification,
            contentLocation,
            contentSize,
            defaultActiveElement,
            escDismiss,
            enterPrimary,
            footerButtonProps,
            lightDismiss,
            modal,
            onDismiss,
            overlay,
            resizable,
            showCloseButton
        } = this.props;

        const titleProps = { ...this.props.titleProps };

        const id = this.props.id || this.dialogId;
        const titleId = titleProps.id ? titleProps.id : titleProps.text ? `${id}-title` : undefined;
        titleProps.id = titleId;

        if (titleProps.size === undefined) {
            titleProps.size = TitleSize.Small;
        }

        return (
            <CustomDialog
                ariaDescribedBy={ariaDescribedBy}
                ariaLabel={ariaLabel}
                ariaLabelledBy={ariaLabelledBy || titleId}
                blurDismiss={blurDismiss}
                calloutClassName={calloutClassName}
                calloutContentClassName={calloutContentClassName}
                contentLocation={contentLocation}
                contentJustification={contentJustification}
                className={css("bolt-dialog", className)}
                defaultActiveElement={defaultActiveElement}
                escDismiss={escDismiss}
                id={id}
                lightDismiss={lightDismiss}
                modal={modal}
                onDismiss={onDismiss}
                overlay={overlay}
                contentSize={contentSize}
                resizable={resizable}
                enterPrimary={enterPrimary}
                primaryButtonProps={footerButtonProps?.find(button => button.primary)}
            >
                <PanelHeader
                    onDismiss={onDismiss}
                    closeButtonSize={PanelCloseButtonSize.small}
                    showCloseButton={showCloseButton}
                    showSeparator={false}
                    titleProps={titleProps}
                />
                <SurfaceContext.Consumer>
                    {surfaceContext => (
                        <div
                            className={css(
                                "bolt-dialog-content flex-column flex-grow",
                                !footerButtonProps && "bolt-dialog-content-bottom-padding",
                                surfaceContext.horizontalClassName
                            )}
                        >
                            {this.props.children}
                        </div>
                    )}
                </SurfaceContext.Consumer>
                {footerButtonProps && (
                    <PanelFooter className={css(resizable && "bolt-dialog-resizable-footer")} showSeparator={false} buttonProps={footerButtonProps} />
                )}
            </CustomDialog>
        );
    }
}
